import gql from "graphql-tag"

const fragment = gql`
  fragment card on Card {
    uuid
    userUuid
    fidelCardUuid
    countryCode
    lastFour
    expMonth
    expYear
    syncToFidelError
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
`

export default fragment
